let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bFS2f")).then(() => parcelRequire('bz48R'));